const Lemo_Modal = {

    backdrop: 'satic',
    buttons: {},
    content: null,
    id: 'modal',
    size: null,
    title: null,

    /**
     * Prida tlacitko do modalniho okna
     *
     * @param {string} id
     * @param {string} label
     * @param {string} classs
     * @param {function} callback
     */
    addButton: function (id, label, classs, callback) {
        this.buttons[id] = {};
        this.buttons[id].label = label;
        this.buttons[id].classs = classs;
        this.buttons[id].callback = callback;

        return this;
    },

    /**
     * Sestaveni modalniho okna
     *
     * @returns {boolean}
     */
    build: function (callback) {
        var modalSelector = '#' + this.id;
        var modalContainer = $(modalSelector);
        if (modalContainer.length) {
            this.reset();
            return this;
        }

        var size = '';
        if ('large' == this.size) {
            size = ' modal-lg';
        }
        if ('small' == this.size) {
            size = ' modal-sm';
        }

        var html = $('<div id="' + this.id + '" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"></div>');
        var htmlModalDialog = $('<div class="modal-dialog' + size + '" role="document"></div>');
        var htmlModalContent = $('<div class="modal-content"></div>');
        var htmlModalHeader = $('<div class="modal-header"></div>');
        var htmlModalBody = $('<div class="modal-body" id="dialogBody">' + this.content + '</div>');
        var htmlModalFooter = $('<div class="modal-footer" id="dialogButtons"></div>');

        // Hlavicka
        if ('' != this.title) {
            htmlModalHeader.append('<h5 class="modal-title">' + translate(this.title) + '</h5>');
            htmlModalHeader.append('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>');

            htmlModalContent.append(htmlModalHeader);
        }

        // Obsah
        htmlModalContent.append(htmlModalBody);

        // Paticka
        if (typeof this.buttons != 'undefined') {
            $.each(this.buttons, function (i, attribs) {
                var button = $('<button>' + translate(attribs.label) + '</button>')
                    .attr('class', ('' == attribs.classs) ? 'btn' : attribs.classs)
                    .on('click.lemocore.modal', attribs.callback);

                htmlModalFooter.append(button);
            });

            htmlModalContent.append(htmlModalFooter);
        }

        htmlModalDialog.append(htmlModalContent);
        html.append(htmlModalDialog);

        $('body').append(html);

        modalContainer = $(modalSelector);
        modalContainer.last().modal({
            backdrop: "static",
            show: true
        });

        // Zavreni krizkem
        modalContainer.last().find('.modal-header > .close').on('click.lemocore.modal', function (e) {
            e.preventDefault();
            Lemo_Modal.close();
        });

        // Zavreni modal ESC
        $(document)
            .off('keydown.lemocore.modal')
            .on('keydown.lemocore.modal', function (e) {
                let code = parseInt(e.keyCode ? e.keyCode : e.which);
                if (code === 27) {
                    e.preventDefault();
                    Lemo_Modal.close();
                }
            });

            // Zavreni modal pri kliknuti mimo okno, nebo autocomplete
            // $(document)
            //     .off('mousedown.lemocore.modal')
            //     .on('mousedown.lemocore.modal', function (e) {
            //         var code = e.keyCode ? e.keyCode : e.which;
            //         if (code == 1) {
            //             if (
            //                 !$(e.target).parents('.modal-dialog').length
            //                 && !$(e.target).parents('.ui-autocomplete').length
            //                 && !$(e.target).parents('#alert-container').length
            //                 && !$(e.target).parents('#contextmenu').length
            //             ) {
            //                 e.preventDefault();
            //                 Lemo_Modal.close();
            //             }
            //         }
            //     });

        this.enableSubmitOnEnter();
        this.reset();

        // Callback
        if (callback && typeof(callback) === 'function') {
            callback();
        }

        return this;
    },

    createUploadIframe: function (miniformType) {

        var iframe = $('#uploadiframe');
        if ('file' == miniformType && !iframe.length) {
            $('body').append('<iframe id="uploadiframe" name="uploadiframe" style="display: none"></iframe>');
        }

        return this;
    },

    enableSubmitOnEnter: function () {
        $('.modal')
            .last()
            .off('keydown.lemocore.modal', ':input')
            .on('keydown.lemocore.modal', ':input:not(textarea)', function (e) {
                var code = e.keyCode ? e.keyCode : e.which;
                if (13 == code) {
                    e.preventDefault();

                    if ($(this).hasClass('ui-autocomplete-input')) {
                        return false;
                    }

                    var button = $('.modal').find('.modal-footer > button').eq(0);
                    if (button.length && 'disabled' != button.attr('disabled')) {
                        Lemo_Modal.disableSubmitOnEnter();
                        button.trigger('click');
                    }
                    return false;
                }
                return true;
            });

        return this;
    },

    disableSubmitOnEnter: function () {
        $('.modal')
            .last()
            .off('keydown.lemocore.modal', ':input')
            .off('keypress', ':input')
            .off('keyup', ':input');

        return this;
    },

    /**
     * Vyresetuje hodnoty modalniho okna
     */
    reset: function () {
        this.buttons = {};
        this.content = null;
        this.id = 'modal';
        this.title = null;
        return this;
    },

    /**
     * Zavre posledni modalni okno
     */
    close: function () {
        $('.modal')
            .last()
            .one('hidden.bs.modal', function (e) {
                e.preventDefault();
                $(this).remove();

                // Odstraneni .lemocore.modal eventu pri uzavreni posledniho okna
                var modalContainer = $(document).find('.modal');
                if (!modalContainer.length) {
                    $(document).off('.lemocore.modal');
                }
            })
            .modal('hide');

        // Odstrani pripadny iframe
        var iframe = $('#uploadiframe');
        if (iframe.length) {
            iframe.remove();
        }

        return this;
    },

    /**
     * Nastavi obsah modalniho okna
     *
     * @param content
     */
    setContent: function (content) {
        this.content = content;
        return this;
    },

    /**
     * Nastavi ID modalniho okna
     *
     * @param id
     */
    setId: function (id) {
        this.id = id;
        return this;
    },

    /**
     * Nastavi velikost modalniho okna
     *
     * @param size
     */
    setSize: function (size) {
        if ('large' === size || 'small' === size) {
            this.size = size;
        } else {
            console.log("Unsupported modal size. Supported is only 'large' or 'small'");
        }
        return this;
    },

    /**
     * Nastavi nadpis modalniho okna
     *
     * @param title
     */
    setTitle: function (title) {
        this.title = title;
        return this;
    }
}
